import client from '../httpClient';

const schedulesPostApi = (modifyObj) => {
  return client.post('/schedules', JSON.stringify(modifyObj), { isShowLoading: false });
};

export default schedulesPostApi;
